const field = [{
  desc: '获取保单字段接口(分页/不分页)',
  options: {
    url: '/busi/busiFieldsPage',
    method: 'post'
  },
  vuex: true
}, {
  desc: '编辑保单字段接口(编辑角色，禁用，启用)',
  options: {
    url: '/busi/editBusiFields',
    method: 'post'
  }
}, {
  desc: '场景信息查询接口(分页)',
  options: {
    url: '/busi/busiSceneConfigPage',
    method: 'post'
  }
}, {
  desc: '编辑或新增场景信息',
  options: {
    url: '/busi/addOrUpdateBusiSceneConfig',
    method: 'post'
  }
}, {
  desc: '删除场景信息',
  options: {
    url: '/busi/updateBusiSceneConfigStatus',
    method: 'post'
  }
}, {
  desc: '查询枚举信息',
  options: {
    url: '/busi/getBusiDict',
    method: 'post'
  }
}, {
  desc: '导出场景信息查询接口',
  options: {
    url: '/busi/queryExportBusiSceneConfig',
    method: 'post'
  }
}]
export default field



// WEBPACK FOOTER //
// ./src/api/field.js